import moment from "moment";

export default ({ handleChange, endDateName, endDateValue }) => name => value => {
  const defaultEndDate = moment(value)
    .second(0)
    .millisecond(0)
    .add(120, "m")
    .toDate();

  handleChange(name)(value);
  if (!endDateValue) {
    handleChange(endDateName)(defaultEndDate);
  }
};
